// Bubble outlines inside the Neos guest frame; in the backend bubbles only indicate, they are not clickable.
export default class GraphicEditor {
    static init() {
        // Only in the Neos guest frame.
        if (window.parent === window) return;
        const roots = () => document.querySelectorAll('.interactive-graphic[data-editable="true"]');
        const outline = (root, className, bubbles) => root.querySelectorAll('[data-bubble-id]').forEach(element => {
            element.classList.toggle(className, bubbles.includes(element));
        });

        // Links follow the infoboxes' bubble lists, so a changed list shows without a page reload.
        // The first infobox wins a bubble two of them name, as on the server.
        const link = root => {
            const owners = {};
            root.querySelectorAll('.interactive-graphic__panel[data-bubbles]').forEach(panel => {
                panel.dataset.bubbles.split(' ').filter(Boolean).forEach(id => { owners[id] ??= panel.id; });
            });
            root.querySelectorAll('[data-bubble-id]').forEach(bubble => {
                const owner = owners[bubble.dataset.bubbleId];
                if (owner) bubble.dataset.panel = owner;
                else delete bubble.dataset.panel;
            });
        };

        // The focused node, from the host; a focused infobox outlines itself and its bubbles.
        let focusedPath = null;
        let activeRoot = null;
        const highlight = () => {
            activeRoot = null;
            roots().forEach(root => {
                const node = focusedPath ? [...root.querySelectorAll('[data-__neos-node-contextpath]')]
                    .find(element => element.getAttribute('data-__neos-node-contextpath') === focusedPath) : null;
                const panel = node?.closest('.interactive-graphic__panel') || null;
                if (panel) activeRoot = root;
                outline(root, 'is-inspector-highlighted', panel ? [...root.querySelectorAll(`[data-bubble-id][data-panel="${panel.id}"]`)] : []);
                root.querySelectorAll('.interactive-graphic__panel').forEach(element => {
                    element.classList.toggle('is-inspector-highlighted', element === panel);
                });
            });
        };

        // Neos replaces a re-rendered infobox or graphic; relink and outline again once per frame.
        let pending = false;
        const refresh = () => {
            if (pending) return;
            pending = true;
            requestAnimationFrame(() => {
                pending = false;
                roots().forEach(link);
                highlight();
            });
        };
        const watch = () => {
            refresh();
            new MutationObserver(refresh).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-bubbles']});
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, {once: true});
        else watch();

        window.addEventListener('message', event => {
            if (event.source !== window.parent) return;
            if (event.data?.type === 'CodeQ.Site:HighlightGraphicNode') {
                focusedPath = event.data.contextPath;
                highlight();
            }
            // The bubble under the pointer in the inspector's bubble list.
            if (event.data?.type === 'CodeQ.Site:HoverGraphicBubble') {
                const bubble = event.data.bubbleId ? activeRoot?.querySelector(`[data-bubble-id="${event.data.bubbleId}"]`) : null;
                roots().forEach(root => outline(root, 'is-hover-highlighted', bubble && root === activeRoot ? [bubble] : []));
            }
        });
    }
}
